export default function downloadFileByLink(url: string, title: string) {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.setAttribute('download', `${title}.pdf`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// The `download` attribute is ignored for cross-origin URLs (e.g. a signed S3 link), so the
// browser would just open the file. Fetch it into a blob to keep the file name; if the
// fetch is blocked (CORS), fall back to opening the link.
export async function downloadPdf(url: string, title: string) {
  if (url.startsWith('blob:')) {
    downloadFileByLink(url, title);
    return;
  }

  let blobUrl: string | undefined;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Download failed: ${response.status}`);
    }
    blobUrl = URL.createObjectURL(await response.blob());
  } catch {
    downloadFileByLink(url, title);
    return;
  }

  downloadFileByLink(blobUrl, title);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
}
